type UserOpponentsDetailsFilters = {
	userOpponentsDetailsFrom: number;
	userOpponentsDetailsTill: number;
};

const COLUMNS_NAME = [
	'Zupee User Id',
	'Ludo Tournament Id',
	'Playing Table Id',
	'Game Type',
	'Entry Fee',
	'Total Players',
	'Event Time',
	'User Device Id',
	'User Ip Address',
	'Opp. Zupee User Id',
	'Opp. Device Id',
	'Opp. Ip Address',
	'Opp. Username',
	'Opp. Phone',
	'Opp. Email',
	'Opp. Upi',
	'Opp. Bank Account No',
	'Opp. Bank Account Holder',
	'Opp. Bank Account IFSC'
];

export { COLUMNS_NAME };

export type { UserOpponentsDetailsFilters };
